import React, { createContext, useState, useEffect, useContext } from 'react';
import api from '../services/api';
import { useLocation } from 'react-router-dom';

export const SettingsContext = createContext();

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const loadSettings = async () => {
    try {
      const res = await api.get('/settings');
      setSettings(res.data);
      
      // Apply brand colors/themes globally via CSS variables
      if (res.data.brand_color) document.documentElement.style.setProperty('--brand', res.data.brand_color);
      if (res.data.theme_bg_main) document.documentElement.style.setProperty('--bg-main', res.data.theme_bg_main);
      if (res.data.theme_sidebar) document.documentElement.style.setProperty('--sidebar', res.data.theme_sidebar);
      if (res.data.theme_text_main) document.documentElement.style.setProperty('--text-main', res.data.theme_text_main);
      
      setLoading(false);
    } catch (err) {
      console.error('Failed to load settings:', err);
      setLoading(false);
    }
  };

  useEffect(() => {
    loadSettings();
  }, [location.pathname]); // Re-check on navigation

  const updateSettings = async (updates) => {
    // Optimistic update
    setSettings(prev => ({ ...prev, ...updates }));
    
    // Apply colors immediately if changed
    if (updates.brand_color) document.documentElement.style.setProperty('--brand', updates.brand_color);
    
    try {
      await api.post('/settings', updates);
      // Re-load to ensure sync
      await loadSettings();
    } catch (err) {
      console.error('Failed to update settings:', err);
      // Rollback could go here if needed
    }
  };

  const currencySymbol = settings.currency_symbol || '$';

  return (
    <SettingsContext.Provider value={{ settings, currencySymbol, updateSettings, loading, reloadSettings: loadSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
